import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import styles from './UploadButton.module.css';

const UploadButton = ({ accept, onUpload, text = 'Upload', disabled = false }) => {
    const [id] = useState(uuidv4());

    const upload = (e) => {
        onUpload(e.target.files);
        e.target.value = null;
    };

    return (
        <>
            <label className={styles.label} htmlFor={id}>
                <div className={styles.button}>
                    <i className="fa fa-upload" />
                    <span className={styles.buttonText}>{text}</span>
                </div>
            </label>
            <input
                style={{ display: 'none' }}
                id={id}
                type="file"
                accept={accept}
                onChange={upload}
                disabled={disabled}
            />
        </>
    );
};

export default React.memo(UploadButton);
